module.exports = __webpack_public_path__ + "assets/img/lang.b00cd213.gif";